export { default } from './TextModule';
export { default as adapter } from './adapter';
